import React, { useContext } from "react";

import TabbedView from "../lists/TabbedView/TabbedView";
import TabbedViewPage from "../lists/TabbedView/TabbedViewPage";
import UserManagement from "./UserManager";
import RolesAndPermissions from "./rolesAndPermissions/RolesAndPermissions";
import { SessionContext } from "../../utility/useSession";
import { isSysAdmin } from "../../utility/utils";
import { useTranslation } from "react-i18next";

const UserSettingsManager: React.FC = () => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    return (
        <TabbedView data-testid="user-settings-tabs">
            <TabbedViewPage title={t("users.manageUsersTab")} data-testid="manage-users-tab">
                <UserManagement />
            </TabbedViewPage>

            <TabbedViewPage
                title={t("users.rolesAndPermissionsTab")}
                visible={isSysAdmin(session)}
                data-testid="roles-permissions-tab"
            >
                <RolesAndPermissions />
            </TabbedViewPage>
        </TabbedView>
    );
};

export default UserSettingsManager; 